import { render } from "./Coupe.vue?vue&type=template&id=87564206"
import script from "./Coupe.vue?vue&type=script&lang=js"
export * from "./Coupe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Coupe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87564206"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87564206', __exports__)) {
    api.reload('87564206', __exports__)
  }
  
  module.hot.accept("./Coupe.vue?vue&type=template&id=87564206", () => {
    api.rerender('87564206', render)
  })

}


export default __exports__